import React from 'react';
import { isSafeUrl } from '@atlaskit/adf-schema';
import { LazySingleLineSmartLink } from '@atlassian/jira-issue-field-smart-link/src/ui/single-line-smart-link/async.tsx';
import { CustomFieldTooltip } from '../custom-field-tooltip/index.tsx';
import { TextCardCustomFieldContent } from '../text-card-custom-field-content/index.tsx';
import type { UrlCustomField } from '../types.tsx';

type Props = { field: UrlCustomField };

export const TextSmartLinkCustomFieldContent = ({ field }: Props) =>
	field.text && isSafeUrl(field.text) ? (
		<LazySingleLineSmartLink anchorTarget="_blank" url={field.text} />
	) : (
		<CustomFieldTooltip field={field}>
			<TextCardCustomFieldContent field={field} />
		</CustomFieldTooltip>
	);
